import { CSSProperties } from 'react';
import {
    BuyFin,
    Financeit,
    GoodLeap,
    GreenSky,
    ServiceFinance,
    Synchrony,
    Turns,
    WellsFargo,
    Affirm,
    Finturf,
} from '../index';

export interface ProviderLogoProps {
    /** The name of the provider to display the logo for */
    provider: string | null | undefined;
    /** Custom height for the logo (default: 20px) */
    height?: string;
    /** Custom max width for the logo (default: 60px) */
    maxWidth?: string;
    /** Additional CSS styles to apply to the logo */
    style?: CSSProperties;
}

export const ProviderLogo = ({
    provider,
    height = '20px',
    maxWidth = '60px',
    style = {},
}: ProviderLogoProps) => {
    const logos = {
        BuyFin,
        Financeit,
        GoodLeap,
        GreenSky,
        ServiceFinance,
        WellsFargo,
        Synchrony,
        Turns,
        Affirm,
        Finturf,
    };

    if (!provider || !(provider in logos)) {
        return null;
    }

    return (
        <img
            style={{
                height,
                maxWidth,
                objectFit: 'scale-down',
                ...style,
            }}
            src={(logos as { [k: string]: string })[provider]}
            alt={`${provider} logo`}
        />
    );
};
